// Platform upgrade window, Bangladesh time (UTC+6).
export const UPGRADE_START = new Date('2026-10-13T06:00:00+06:00')
export const UPGRADE_END = new Date('2026-10-13T23:00:00+06:00')
export const UPGRADE_WINDOW_LABEL = '13 October 2026, from 6:00 AM to 11:00 PM (Bangladesh time)'
